import { BigNumber } from 'bignumber.js';
import { cloneDeep } from 'lodash';
import FooterControl from '@/components/FooterControl.vue';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import scrollbar from '@/mixins/scrollbar';
import payDialog from '../pay/index.vue';
import { validatePhoneNoRequired, checkIDCard } from '@/utils/validate/elementMethod';
import { REG_P_INT, REG_AMT, REG_T_ZEAR } from '@/utils/validate/regExp';
import receiptPrint from '@/components/receiptPrint/index.vue';
import { getLodop } from '@/plugins/LodopFuncs';
import noPrintTips from '@/components/noPrintTips.vue';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  name: 'sale-drug',
  mixins: [scrollbar],
  components: { FooterControl, HisAutocompleteSuggestions, payDialog, receiptPrint, noPrintTips },
  data() {
    const checkAge = (rule, value, callback) => {
      if (this.ageForm.showYear && !this.ageForm.showMonth && !this.ageForm.showDay) {
        if (this.patient.year === '') {
          callback();
        }
        if (!REG_T_ZEAR.test(this.patient.year)) {
          callback(new Error('请输入正确的年龄'));
        }
      }
      if (this.ageForm.showYear && this.ageForm.showMonth && !this.ageForm.showDay) {
        if (this.patient.year === '' && this.patient.month === '') {
          callback();
        }
        if (this.patient.year && !REG_T_ZEAR.test(this.patient.year)) {
          callback(new Error('请输入正确的年龄'));
        }
        if (this.patient.month && !REG_T_ZEAR.test(this.patient.month)) {
          callback(new Error('请输入正确的年龄'));
        }
      }
      if (!this.ageForm.showYear && this.ageForm.showMonth && this.ageForm.showDay) {
        if (this.patient.month === '' && this.patient.day === '') {
          callback();
        }
        if (this.patient.month && !REG_T_ZEAR.test(this.patient.month)) {
          callback(new Error('请输入正确的年龄'));
        }
        if (this.patient.day && !REG_T_ZEAR.test(this.patient.day)) {
          callback(new Error('请输入正确的年龄'));
        }
      }
      if (this.patient.year >= 150) {
        callback(new Error('年龄在0-150之间'));
      }
      callback();
    };
    return {
      qvalue: '',
      centerDialogVisible: false,
      doctorId: '', // 医生ID
      checked: '',
      ageForm: {
        showYear: true,
        showMonth: false,
        showDay: false,
      },
      ruleForm: {
        name: '',
        drugType: '1',
      },
      rules: {
        age: [{
          required: false,
          validator: checkAge,
          trigger: 'change',
        }],
        phoneNo: [
          { required: false, validator: validatePhoneNoRequired, trigger: 'change' },
        ],
        idCardNo: [
          { validator: checkIDCard, trigger: 'change' },
        ],
      },
      options: [],
      value: '',
      hasExam: false,
      hasAddition: false,
      paitentDisable: false, // 控制姓名不能修改
      patient: {
        patientName: '',
        gender: 1,
        year: '',
        month: 0,
        day: 0,
        phoneNo: '',
        idCardNo: '',
      },
      orderExam: {
        discountAmt: 0,
        receivableAmt: 0,
        items: [{
          examId: '',
          count: 1,
          examName: '',
          currentValue: '',
        }],
      },
      orderAddition: {
        discountAmt: 0,
        receivableAmt: 0,
        items: [{ amtName: '', salePrice: 0 }],
      },
      orderPrescription: {
        discountAmt: 0,
        receivableAmt: 0,
        items: [],
      },
      examOptions: [], // 检查治疗项列表
      wipeAmt: 0,
      dialogVisible: false, // 支付窗口
      serverTotal: null,
      orderId: 0,
      couponDiscountAmt: 0, // 优惠券金额
      hasCoupon: false,
      couponId: '',
      couponType: 0,
      couponVal: {},
      doctorList: [], // 诊所医生列表
      scriptList: {},
      realName: '', // 医生名称
      review: true, // 是否开启打印预览模式
      printShow: false,
      debtorInfo: { // 传入子组件默认的欠费人信息
        name: '',
        phone: '',
      },
      examQuery: {
        currentPage: 1,
        pageSize: 10,
      }, // 检查治疗项分页查询
      totalExam: 0, // 检查治疗项分页总数
      checkedExam: [], // 选中的检查治疗项
      sellDrugWithoutInventory: 1, // 是否开启无库存售药 1：是 0：否
    };
  },

  methods: {
    initDrug() {
      const array = [
        { drugName: '', isWarning: false, currentValue: '' },
        { drugName: '', isWarning: false, currentValue: '' },
        { drugName: '', isWarning: false, currentValue: '' },
        { drugName: '', isWarning: false, currentValue: '' },
        { drugName: '', isWarning: false, currentValue: '' },
      ];
      this.orderPrescription.items = this.orderPrescription.items.concat(array);
    },
    openCheckLine() {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.examOptions.clearSelection();
      });
    },
    querySearch(str, cb) {
      this.$api.drugControl.drugsNameList({
        drugName: str,
      }).then((res) => {
        res.drugList = res.drugList.map((item) => {
          const drug = {
            drugName: item.drugName,
            specification: item.specification,
            manufacturer: item.manufacturer,
            drugId: item.id,
          };
          return drug;
        });
        cb(res.drugList);
      });
    },
    queryDrug(str, cb, index) {
      this.$set(this.orderPrescription.items, index, { drugName: str, isWarning: false, currentValue: '' });
      // this.orderPrescription.items[index] = { drugName: str, isWarning: false, currentValue: '' };
      this.$api.drugControl.getDrugByName({ drugName: str }).then((res) => {
        cb(res);
      }).catch(() => {
        cb([]);
      });
    },
    // 通过药品ID获取药品详情 ======== 药品入口
    selectHandleDrug(drugId, index) {
      // 列表禁止选择相同的药品
      const hasSameDrug = this.orderPrescription.items.map(item => item.drugId).indexOf(drugId);
      if (hasSameDrug !== -1) {
        this.$message({
          type: 'warning',
          message: '该药已在列表中！',
        });
        return;
      }
      // 初始化药品数据内容
      const initSalePrice = (list, status) => {
        const arr = list.map((item) => {
          const sale = item.sale[item.sale.length - 1]; // 取最后一个单位
          // 判断 batches 是否为空为空就给他 ’--‘
          const batches = item.batches.map((it) => {
            const batche = { ...it };
            if (!it.batchNo) batche.batchNo = '--';
            return batche;
          });
          const obj = {
            ...item,
            saleUnit: sale.unitName,
            salePrice: sale.drugSalePrice,
            currentValue: status === 'noInstock' ? '' : item.drugName, // 在无库存的时候当前不给选中的值 || 当前选中的值
            batches,
            drugBatchNo: batches[0].batchNo, // 默认给第一批号
            initPopover: false, // 初始化popover
            isInventoryWarning: false, // 初始化 库存提示的icon
          };
          return obj;
        });
        return arr;
      };
      this.$api.feeDispense.sellDrugDetail({ drugId }).then((res) => {
        const response = res;
        let status = '';
        if (res[0].batches.length === 0) {
          // 当前item 提示无库存
          this.orderPrescription.items[index].currentValue = '';
          response[0].tipContentDrug = '该药没有库存！';
          status = 'noInstock';
          response[0].batches.push({ batchNo: '', inventory: '' }); // 允许售卖无库存添加初始化批次值
          if (this.sellDrugWithoutInventory) {
            this.$message({
              type: 'warning',
              message: '该药没有库存！',
            });
          } else {
            this.$message({
              type: 'error',
              message: '该药没有库存！',
            });
            return; // 不允许售卖无库存药品
          }
        }
        if (res[0].sale.length === 0) {
          this.orderPrescription.items[index].currentValue = '';
          this.orderPrescription.items[index].tipContentDrug = '药品没有设置零售价，无法收费！';
          this.$message({
            type: 'warning',
            message: '药品没有设置零售价，无法收费！',
          });
          return;
        }
        const drugList = initSalePrice(response, status);
        // 当前处理只有一种药的情况 常规情况
        const [drug] = drugList;
        console.log(drug);
        
        this.$set(this.orderPrescription.items, index, drug);
        const selectedDrugNum = this.orderPrescription.items.filter(item => !item.drugId).length;
        if (selectedDrugNum === 0) this.orderPrescription.items.push({ drugName: '', currentValue: '' });
        this.$nextTick(() => {
          document.querySelectorAll('.suggestions-input')[index + 1].querySelector('input').focus();
        });
      });
    },
    // 改变药品单位获取药品价格
    changePrice(e, index) {
      const drugSale = this.orderPrescription.items[index].sale.find(item => item.unitName === e);
      this.orderPrescription.items[index].salePrice = drugSale.drugSalePrice;
      this.orderPrescription.items[index].unitName = drugSale.unitName;
    },
    // 删除单个药品
    delDrug(index) {
      if (this.orderPrescription.items.length === 1) return;
      this.orderPrescription.items.splice(index, 1);
    },
    dosageChange(item, e, index) {
      // 开药量修改 判断是否符合库存
      const { ratio } = item.sale.find(it => it.unitName === item.saleUnit);
      this.orderPrescription.items[index].isInventoryWarning = e * ratio > item.inventoryCount;
      // 从后台获取多个药品批次的药事件
      console.log(item);
    },
    // 药品单项合计金额
    drugAmt(price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.000';
      return BN(price).multipliedBy(num).toFixed(3);
    },
    examNameItemAmt(price, num) {
      // console.log(price, num);
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.000';
      return BN(price).multipliedBy(num).toFixed(3);
    },
    // 获取患者信息
    queryPatient(patientName, cb) {
      this.$api.outPatient.getHospitalPatient({ patientName }).then((res) => {
        cb(res);
      }).catch(() => {
        cb([]);
      });
    },
    handleSelectPatient(patient) {
      this.patient = {
        ...this.patient,
        ...patient,
      };
      this.dayHandle();
      this.paitentDisable = true;
    },
    clearPatient() {
      this.paitentDisable = false;
      this.patient = {
        patientName: '',
        gender: 1,
        year: '',
        month: 0,
        day: 0,
        phoneNo: '',
        idCardNo: '',
      };
      this.ageForm = {
        showYear: true,
        showMonth: false,
        showDay: false,
      };
    },
    // 添加附加费用
    addAddition() {
      this.orderAddition.items.push({ amtName: '', salePrice: 0 });
    },
    // 删除一条附加费用
    delAddition(index) {
      if (this.orderAddition.items.length === 1) {
        this.$set(this.orderAddition.items, index, {
          amtName: '',
          salePrice: 0,
        });
        return;
      }
      this.orderAddition.items.splice(index, 1);
    },
    // 获取检查治疗项
    getExamAll() {
      this.$api.clinicManagement.listPagedExam(this.examQuery).then((res) => {
        this.examOptions = res.examList.map((item) => {
          return {
            ...item,
            cost: item.examCost,
          };
        });
        this.totalExam = res.totalSize || 0;
      });
    },
    // 检查治疗项翻页
    pageChangeExam(e) {
      this.examQuery.currentPage = e;
      this.getExamAll();
    },
    // 勾选常用处方模板
    handleExamChange(val) {
      this.checkedExam = val;
    },
    // 选择检查治疗项
    selectExamList() {
      this.checkedExam.forEach((item) => {
        this.orderExam.items.push({
          examId: item.examId,
          examName: item.examName,
          salePrice: item.examPrice,
          cost: item.examCost,
          count: 1,
          initName: item.examName, // 初始化 组件内部的 currentvalue 值 为了不让组件显示感叹号提示
        });
      });
      this.checkedExam = []; // 清空选项
      this.centerDialogVisible = false;
    },
    // 删除检查治疗项
    delExamItem(index) {
      if (this.orderExam.items.length === 1) {
        // if (this.orderExam.items.length === 1 || !this.orderExam.items[index].examId) {
        this.$set(this.orderExam.items, index, {
          examId: '',
          count: 1,
          examName: '',
          currentValue: '',
        });
        return;
      }
      // if (this.orderExam.items.length === 1 || !this.orderExam.items[index].examId) return;
      this.orderExam.items.splice(index, 1);
    },
    // 关键词搜索
    queryExam(name, cb) {
      this.$api.outPatient.getExamList({ examName: name }).then((res) => {
        const result = res.map(item => ({ ...item, cost: item.examCost }));
        cb(result);
      }).catch(() => {
        cb([]);
      });
    },
    handleSelectExam(event, index) {
      this.$set(this.orderExam.items, index, {
        ...event,
        count: 1,
        salePrice: event.examPrice,
        currentValue: event.examName,
      });
      const selectedExam = this.orderExam.items.filter(item => !item.examId).length;
      if (selectedExam === 0) {
        this.orderExam.items.push({ examName: '', currentValue: '' });
      }
    },
    // 获取优惠券
    getCoupon() {
      this.$api.member.coupon({ id: this.couponId }).then((res) => {
        this.couponType = res.paramType;
        this.couponVal = JSON.parse(res.paramValue);
      });
    },
    // 提交收费
    confirm() {
      const orderPrescription = cloneDeep(this.orderPrescription);
      orderPrescription.items = orderPrescription.items.filter(item => item.drugId);
      let orderExam = cloneDeep(this.orderExam);
      orderExam.items = orderExam.items.filter(item => item.examId);
      orderExam.receivableAmt = this.examAmt;
      // 判断用户有没有选择添加治疗项
      if (!this.hasExam) {
        orderExam = {
          discountAmt: 0,
          receivableAmt: 0,
          items: [],
        };
      }
      let orderAddition = cloneDeep(this.orderAddition);
      orderAddition.items = orderAddition.items.filter(item => item.amtName);
      this.orderAddition.receivableAmt = this.addtionAmt;

      // 判断用户有没有选择添加附加费用
      if (!this.hasAddition) {
        orderAddition = {
          discountAmt: 0,
          receivableAmt: 0,
          items: [],
        };
      }
      // 药品列表 检查治疗项 附加费用的优惠是否为空字符串 如果为空字符串则给
      if (!orderPrescription.discountAmt) orderPrescription.discountAmt = 0;
      if (!orderAddition.discountAmt) orderAddition.discountAmt = 0;
      if (!orderExam.discountAmt) orderExam.discountAmt = 0;

      const req = {
        orderAddition,
        orderExam,
        orderPrescription,
        actualReceivableAmt: this.actualReceivableAmt,
        receivableAmt: this.totalAmt || 0,
        discountAmt: this.offer || 0,
        wipeAmt: this.wipeAmt || 0,
        couponDiscountAmt: this.couponAmt || 0,
        couponCode: this.couponCode,
        doctorId: this.doctorId,
      };
      // 验证药品信息填写内容 名称 | 数量
      const scriptNameValidate = orderPrescription.items.some(item => (item.currentValue !== item.drugName && !item.tipContentDrug));
      // 药品库存数量
      const scriptInventoryValidate = orderPrescription.items.some(item => item.isInventoryWarning);
      const scriptNameInventoryvalidate = orderPrescription.items.some(item => (item.currentValue !== item.drugName && item.tipContentDrug === '该药没有库存！'));
      const scriptNumberValidate = orderPrescription.items.some(item => !REG_P_INT.test(item.dosage));
      const ExamNameValidate = orderExam.items.some(item => item.isWarning);
      const ExamNumberValidate = orderExam.items.some(item => !REG_P_INT.test(item.count));
      const addAmtValidate = orderAddition.items.some(item => !REG_AMT.test(item.salePrice));
      if (scriptNameValidate) {
        this.$message({
          message: '部分药品没有录入您的药品信息管理中！',
          type: 'warning',
        });
        return;
      }
      if (ExamNameValidate) {
        this.$message({
          message: '部分检查治疗项不匹配！',
          type: 'warning',
        });
        return;
      }
      if (scriptNumberValidate) {
        this.$message({
          message: '部分药品数量输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (ExamNumberValidate) {
        this.$message({
          message: '部分检查治疗项次数输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (addAmtValidate) {
        this.$message({
          message: '部分附加费用输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (this.scriptAmt < orderPrescription.discountAmt || !REG_AMT.test(orderPrescription.discountAmt)) {
        this.$message({
          message: '药品优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      
      if (this.examAmt < orderExam.discountAmt || !REG_AMT.test(orderPrescription.discountAmt)) {
        this.$message({
          message: '检查治疗项优惠输入不正确！',
          type: 'warning',
        });
        return;
      }

      if (this.addtionAmt < orderAddition.discountAmt || !REG_AMT.test(orderPrescription.discountAmt)) {
        this.$message({
          message: '附加费用优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (parseFloat(this.totalAmt) < parseFloat(this.totalDiscount) || !REG_AMT.test(this.wipeAmt)) {
        this.$message({
          message: '抹零优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      // 有患者信息时需要验证内容
      // 打印拦截如果没有安装打印插件
      const LODOP = getLodop();
      if (!LODOP && this.isPrint) {
        this.printShow = true;
        return;
      }
      // 打印数据输入
      // 修改数据结构
      
      const exam = req.orderExam;
      if (exam) {
        exam.items = exam.items.map(item => ({ ...item, drugName: item.examName }));
      }
      const addition = req.orderAddition;
      if (addition) {
        addition.items = addition.items.map(item => ({ ...item, drugName: item.amtName }));
      }
      
      this.scriptList = {
        saleDrugPrescriptionList: req.orderPrescription, // 成药
        orderExam: exam, // .map(item => ({ ...item, drugName: item.examName })), // 检查治疗项
        orderAddition: addition, // .map(item => ({ ...item, drugName: item.amtName })), // 附加费用
        realName: this.realName, // 给组件传入售药的医生
        receivableAmt: req.receivableAmt, // 合计
        totalDiscountAmt: BN(req.discountAmt).plus(req.wipeAmt).plus(req.couponDiscountAmt).toFixed(2), // 总优惠
        actualReceivableAmt: req.actualReceivableAmt, // 实收
      };
      this.scriptList.patientName = this.patient.patientName;
      console.log(this.scriptList);
      // 有患者信息
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 支付的时候传入默认的欠费人信息
          this.debtorInfo = {
            name: this.patient.patientName,
            phone: this.patient.phoneNo,
          };
          console.log(this.debtorInfo);
          // 年龄处理 如果是空字符串转 0
          if (this.patient.year === '') this.patient.year = 0;
          if (this.patient.month === '') this.patient.month = 0;
          if (this.patient.day === '') this.patient.day = 0;
          req.patient = this.patient; // 患者信息
          if (scriptInventoryValidate || scriptNameInventoryvalidate) {
            console.log(this.sellDrugWithoutInventory);
            if (!this.sellDrugWithoutInventory) {
              this.$message({
                type: 'error',
                message: '部分药品库存不足！',
              });
            } else {
              this.$confirm('部分药品库存不足, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }).then(() => {
                this.request(req);
              }).catch(() => {
              });
            }
            return;
          }
          this.request(req);
        }
      });
      // 库存不足拦截提示
      // if (scriptInventoryValidate || scriptNameInventoryvalidate) {
      //   if (!this.sellDrugWithoutInventory) {
      //     this.$message({
      //       type: 'error',
      //       message: '部分药品库存不足！',
      //     });
      //   } else {
      //     this.$confirm('部分药品库存不足, 是否继续?', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       type: 'warning',
      //     }).then(() => {
      //       this.request(req);
      //     }).catch(() => {
      //     });
      //   }
      //   return;
      // }
      // this.request(req);
    },
    request(req) {
      this.$api.feeDispense.sellDrug(req).then((res) => {
        this.orderId = res.orderId;
        this.serverTotal = res.actualReceivableAmt;
        this.dialogVisible = true;
      });
    },
    // 支付结束清空数据重新开始
    complated() {
      // 打印小票
      this.print();
      this.$refs.ruleForm.resetFields();
      this.hasExam = false;
      this.hasAddition = false;
      this.orderPrescription = {
        discountAmt: 0,
        receivableAmt: 0,
        items: [],
      };
      this.orderExam = {
        discountAmt: 0,
        receivableAmt: 0,
        items: [{ examId: '', count: 1, examName: '' }],
      };
      this.orderAddition = {
        discountAmt: 0,
        receivableAmt: 0,
        items: [{ amtName: '', salePrice: 0 }],
      };
      this.initDrug();
      this.dialogVisible = false;
      this.couponDiscountAmt = 0; // 优惠券金额
      this.wipeAmt = 0; // 抹零金额重置为0
      this.hasCoupon = false;
      this.couponId = '';
      this.couponVal = {};
      // 初始化用户信息
      this.patient = {
        patientName: '',
        gender: 1,
        year: '',
        month: 0,
        day: 0,
        phoneNo: '',
        idCardNo: '',
      };
      this.paitentDisable = false;
      this.ageForm.showYear = true;
      this.ageForm.showMonth = false;
      this.ageForm.showDay = false;
    },
    // 获取医生信息
    getDoctor() {
      this.$api.outPatient.getHospitalDoctor().then((res) => {
        this.doctorList = res;
        // 先做默认第一个 后期本地存储一下
        this.doctorId = res[0].doctorId;
        this.realName = res[0].realName;
      });
    },
    // 打印小票
    print() {
      if (!this.isPrint) return;
      this.$refs.receiptPrint.print();
    },
    // 选择医生
    doctorChange(e) {
      this.realName = this.doctorList.find(item => e === item.doctorId).realName;
    },
    // 判断当前输入药品名是否来自药品库
    checkDrugName(name, id) {
      if (name === '' || id) return false;
      return true;
    },
    // 清空检查治疗项id和价格
    checkDrugExam(index) {
      this.orderExam.items[index].examId = '';
      this.orderExam.items[index].salePrice = '0.00';
    },
    // 开药量输入框焦点事件清空数量
    dosageFocusHandle(index) {
      this.orderPrescription.items[index].dosage = '';
    },
    // 检查治疗项输入框焦点事件清空数量
    countFocusHandle(index) {
      this.orderExam.items[index].count = '';
    },
    // 年龄处理
    yearHandle() {
      const val = this.patient.year;
      if (val < 5 && val > 0) {
        this.ageForm.showMonth = true;
      }
      if (val === 0) {
        this.ageForm.showYear = false;
        this.ageForm.showMonth = true;
        this.ageForm.showDay = true;
      }
      if (val >= 5) {
        this.ageForm.showYear = true;
        this.ageForm.showMonth = false;
        this.ageForm.showDay = false;
        this.patient.month = 0;
        this.patient.day = 0;
      }
      if (this.patient.year > 0 && this.patient.year < 5) {
        this.ageForm.showYear = true;
        this.ageForm.showMonth = true;
        this.ageForm.showDay = false;
        this.patient.day = 0;
      }
    },
    monthHandle() {
      const val = this.patient.month;
      if (val >= 12) {
        const month = val % 12;
        const year = parseInt(val / 12);
        this.patient.year = this.patient.year + year;
        this.patient.month = month;
      }
      this.yearHandle();
    },
    dayHandle() {
      const val = this.patient.day;
      if (val >= 30) {
        const day = val % 30;
        const month = parseInt(val / 30);
        this.patient.month = this.patient.month + month;
        this.patient.day = day;
      }
      this.monthHandle();
      this.yearHandle();
    },
    // 获取诊所基础功能配置
    getHospitalConfig() {
      this.$api.clinicManagement.getHospitalConfig({
        configType: 10,
      }).then((res) => {
        this.sellDrugWithoutInventory = res.sellDrugWithoutInventory;
      });
    },
  },
  mounted() {
    this.getDoctor();
    this.initDrug();
    this.getExamAll();
    this.getHospitalConfig();
  },
  computed: {
    actualReceivableAmt() {
      return BN(this.totalAmt).minus(this.totalDiscount).toFixed(2);
    },
    // 三项应收金额
    totalAmt() {
      let result = BN(this.scriptAmt);
      if (this.hasExam) result = BN(result).plus(this.examAmt);
      if (this.hasAddition) result = BN(result).plus(this.addtionAmt);
      return BN(result).toFixed(2);
    },
    // 所有优惠价格
    totalDiscount() {
      const wipeAmt = this.wipeAmt || 0;
      const couponAmt = this.couponAmt || 0;
      let result = this.offer;
      if (REG_AMT.test(wipeAmt)) result = BN(result).plus(wipeAmt);
      if (REG_AMT.test(couponAmt)) result = BN(result).plus(couponAmt);
      return BN(result).toFixed(2);
    },
    // 处方应收
    scriptAmt() {
      const orderPrescription = cloneDeep(this.orderPrescription);
      orderPrescription.items = orderPrescription.items.filter(item => item.drugId);
      const sub = orderPrescription.items.reduce((a, b) => {
        const salePrice = Number(b.salePrice);
        const dosage = Number(b.dosage);
        let result = 0;
        if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
          result = BN(b.salePrice).multipliedBy(b.dosage).toFixed(3);
        }
        return a + Number(result);
      }, 0);
      // 赋值给orderPrescription
      this.orderPrescription.receivableAmt = sub;
      return sub;
    },
    // 药品实付金额
    orderPrescriptionTotal() {
      const subMeter = Number(this.scriptAmt);
      const discountAmt = Number(this.orderPrescription.discountAmt);
      if (subMeter < discountAmt) return '0.00';
      if (!discountAmt || isNaN(discountAmt)) return BN(this.scriptAmt).toFixed(2);
      return BN(subMeter).minus(discountAmt).toFixed(2);
    },
    addtionAmt() {
      const sub = this.orderAddition.items.reduce((a, b) => {
        const salePrice = Number(b.salePrice);
        let result = 0;
        if (salePrice && !isNaN(salePrice)) {
          result = salePrice;
        }
        return a + result;
      }, 0);
      // 赋值给orderPrescription
      this.orderAddition.receivableAmt = BN(sub).toFixed(3);
      return sub;
    },
    addtionTotal() {
      const subMeter = Number(this.addtionAmt);
      const discountAmt = Number(this.orderAddition.discountAmt);
      if (subMeter < discountAmt) return '0.00';
      if (!discountAmt || isNaN(discountAmt)) return subMeter;
      return BN(subMeter).minus(discountAmt).toFixed(2);
    },
    // 检查项合计总价
    examAmt() {
      const sub = this.orderExam.items.reduce((a, b) => {
        const salePrice = Number(b.salePrice);
        const dosage = Number(b.count);
        let result = 0;
        if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
          result = BN(b.salePrice).multipliedBy(b.count).toFixed(3);
        }
        return a + Number(result);
      }, 0);
      // 赋值给 orderExam
      this.orderExam.receivableAmt = sub;
      return sub;
    },
    // 检查治疗项实收
    examTotal() {
      const subMeter = Number(this.examAmt);
      const discountAmt = Number(this.orderExam.discountAmt);
      if (subMeter < discountAmt) return '0.00';
      if (!discountAmt || isNaN(discountAmt)) return BN(subMeter).toFixed(2);
      return BN(subMeter).minus(discountAmt).toFixed(2);
    },
    // 三项优惠金额
    offer() {
      const orderScript = this.orderPrescription.discountAmt || 0;
      const addScript = this.orderAddition.discountAmt || 0;
      const examScript = this.orderExam.discountAmt || 0;
      let result = 0;
      if (REG_AMT.test(orderScript)) result = BN(result).plus(orderScript);
      if (REG_AMT.test(addScript) && this.hasAddition) result = BN(result).plus(addScript);
      if (REG_AMT.test(examScript) && this.hasExam) result = BN(result).plus(examScript);
      return BN(result).toFixed(2);
    },
    // 优惠券优惠金额
    couponAmt() {
      if (this.hasCoupon && this.couponType !== 0) {
        if (this.couponType === 1) {
          const discount = 1 - this.couponVal.discount;
          return BN(this.totalAmt).minus(this.offer).multipliedBy(discount).toFixed(2);
        }
        if (this.couponType === 2) {
          const price = BN(this.totalAmt).minus(this.offer);
          if (price >= Number(this.couponVal.paramValue1)) {
            return this.couponVal.paramValue2;
          }
          return '0.00';
        }
      }
      return '0.00';
    },
    // 当表单没有填入时按钮不能点击
    confirmDisabled() {
      const hasPre = this.orderPrescription.items.some(item => item.drugId);
      const hasExam = this.orderExam.items.some(item => item.examId);
      const hasAdd = this.orderAddition.items.some(item => item.amtName);
      return !hasPre && !hasExam && !hasAdd;
    },
    // 是否打印小票
    isPrint: {
      get() {
        return this.$store.state.global.printConfig.isReceipt;
      },
      set(val) {
        this.$store.commit('changeReceipt', val);
      },
    },
  },
};
